export type Env = 'local' | 'development' | 'test' | 'acc' | 'production';

export const notaryApiUrl: Record<Env, string> = {
  local: 'http://localhost:3001',
  development: 'https://dev.notary-app.izimi.be',
  test: 'https://tst.notary-app.izimi.be',
  acc: 'https://acc.notary-app.izimi.be',
  production: 'https://izimi.fednot.be',
};

export const citizenApiUrl: Record<Env, string> = {
  local: 'http://localhost:3000',
  development: 'https://dev.app.izimi.be',
  test: 'https://tst.app.izimi.be',
  acc: 'https://acc.app.izimi.be',
  production: 'https://app.izimi.be',
};

export const citizenMobileUrl: Record<Env, string> = {
  local: 'http://localhost:3000',
  development: 'https://dev.mobile.app.izimi.be',
  test: 'https://tst.mobile.app.izimi.be',
  acc: 'https://acc.mobile.app.izimi.be',
  production: 'https://mobile.app.izimi.be',
};

const apiUrls = {
  local: [notaryApiUrl.local, citizenApiUrl.local],
  development: [notaryApiUrl.development, citizenApiUrl.development],
  test: [notaryApiUrl.test, citizenApiUrl.test],
  acc: [notaryApiUrl.acc, citizenApiUrl.acc],
  production: [notaryApiUrl.production, citizenApiUrl.production],
} as const;

const appBasePath = window.location.origin;

const getAppEnv = Object.keys(apiUrls).find((key) => {
  if (key === 'local') {
    return appBasePath.includes('http://localhost');
  }
  return apiUrls[key as keyof typeof apiUrls].includes(appBasePath);
});

// Deciding the environment based on the base path
const viteEnv = import.meta.env.VITE_APP_ENV;
export const appEnv = viteEnv ?? getAppEnv ?? 'development';
